export default {
  time: {
    month: [
      "Jaanuar", "Veebruar", "Märts", "Aprill", "Mai", "Juuni",
      "Juuli", "August", "September", "Oktoober", "November", "Detsember",
    ],
    monthAbbr: [
      "Jan", "Veb", "Mär", "Apr", "Mai", "Jun",
      "Jul", "Aug", "Sep", "Okt", "Nov", "Dets",
    ],
    dayOfWeek: [
      "Pühapäev", "Esmaspäev", "Teisipäev", "Kolmapäev", "Neljapäev", "Reede", "Laupäev",
    ],
    dayOfWeekAbbr: [
      "P", "E", "T", "K", "N", "R", "L",
    ],
  },
  legend: {
    selector: {
      all: "Kõik",
      inverse: "Vastupidi",
    },
  },
  toolbox: {
    brush: {
      title: {
        rect: "Vahemiku valik",
        polygon: "Vaba valik",
        lineX: "Horisontaalne valik",
        lineY: "Vertikaalne valik",
        keep: "Hoia valikud",
        clear: "Tühista valikud",
      },
    },
    dataView: {
      title: "Tabeli vaade",
      lang: ["Tabeli vaade", "Sulge", "Värskenda"],
    },
    dataZoom: {
      title: {
        zoom: "Suurena",
        back: "Tühista suurendus",
      },
    },
    magicType: {
      title: {
        line: "Vaheta joon grafik",
        bar: "Vaheta tulp graafik",
        stack: "Lao",
        tiled: "Ruut",
      },
    },
    restore: {
      title: "Taasta vaade",
    },
    saveAsImage: {
      title: "Salvesta pilt",
      lang: ["Parem klikk, et salvestada pilt"],
    },
  },
  series: {
    typeNames: {
      pie: "Piruka graafik",
      bar: "tulp graafik",
      line: "Joon graafik",
      scatter: "Punkt graafik",
      effectScatter: "Ripple scatter plot",
      radar: "Radar graafik",
      tree: "Puu",
      treemap: "Puu kaart",
      boxplot: "Karp joonestus",
      candlestick: "Küünal",
      k: "K joon graafik",
      heatmap: "Kuumuse graafik",
      map: "Kaart",
      parallel: "Paraleelne joon graafik",
      lines: "Joon graafik",
      graph: "Seoste graafik",
      sankey: "Sankey graafik",
      funnel: "Lehter graafik",
      gauge: "Näidik",
      pictorialBar: "Piltlik tulp graafik",
      themeRiver: "Theme jõe graafik",
      sunburst: "Päikese graafik",
      custom: "Kohandatud graafik",
      chart: "Joon graafik",
    },
  },
  aria: {
    general: {
      withTitle: "See on graafik \"{title} kohta\"",
      withoutTitle: "See on graafik",
    },
    series: {
      single: {
        prefix: "",
        withName: " tüübiga {seriesType} nimetatud {seriesName}.",
        withoutName: " tüübiga {seriesType}.",
      },
      multiple: {
        prefix: ". See koosneb {seriesCount} seeria arvust.",
        withName: " {seriesId} on seeria id {seriesType} mis näitab {seriesName}.",
        withoutName: " {seriesId} seeria on tüüpi {seriesType}.",
        separator: {
          middle: "",
          end: "",
        },
      },
    },
    data: {
      allData: "Andmed on järgnevad: ",
      partialData: "Esimesed {displayCnt} esemed on: ",
      withName: "andmed {name} on {value}",
      withoutName: "{value}",
      separator: {
        middle: ", ",
        end: ". ",
      },
    },
  },
};
